import { render, staticRenderFns } from "./ModalUpdateCertificates.vue?vue&type=template&id=4d820865&"
import script from "./ModalUpdateCertificates.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports